import { EventEmitter } from 'events';
import moment from 'moment-timezone';
import {
  CLOSE_APPOINTMENT_MODAL, GET_APPOINTMENT,
} from '../main/appointments/constants';
import {
  ADD_PAYOUT,
} from '../register/cashRegister/constants';
import {
  CLOCK_IN_MODAL_CLOSE,
  START_TIMER,
} from '../main/timeTracker/constants';
import { BARBER_UPDATED } from '../main/barbers/constants';
import { getLoadedDate } from '../main/appointments/views/sideBySide/selectors';
import { getTimezone } from '../auth/selectors';

const eventsMiddleware = store => next => (action) => {
  next(action);
  switch (action.type) {
    case CLOSE_APPOINTMENT_MODAL:
      EventEmitter.prototype.emit('close-appointment-modal', 'details');
      break;
    case ADD_PAYOUT:
      EventEmitter.prototype.emit('close-payout-modal');
      break;
    case START_TIMER:
    case CLOCK_IN_MODAL_CLOSE:
      EventEmitter.prototype.emit('close-clock-in-modal');
      break;
    case BARBER_UPDATED:
      EventEmitter.prototype.emit('reload-side-by-side');
      break;
    case GET_APPOINTMENT: {
      if (!action.change) {
        break;
      }
      try {
        const timezone = getTimezone(store.getState());
        const loadedDate = moment.tz(getLoadedDate(store.getState()), timezone);
        const appointmentDate = moment.tz(
          action.response.entities.appointments[action.response.result].start,
          timezone
        );

        const trigger = appointmentDate.isSame(loadedDate, 'day');

        if (trigger) {
          EventEmitter.prototype.emit('reload-side-by-side');
        }
      } catch (e) {}
      break;
    }
    default:
  }
};

export default eventsMiddleware;
